import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const MarkdownHeading = superstyled({
  tag: Text,
  name: 'MarkdownRenderer',
  slot: 'MarkdownHeading',
  propsAdded: {
    component: 'p',
    size: 'sm',
  },
  styles: {
    marginBottom: '0.75rem',
    marginTop: '1rem',
  },
});

export const MarkdownParagraph = superstyled({
  tag: Text,
  name: 'MarkdownRenderer',
  slot: 'MarkdownParagraph',
  propsAdded: {
    component: 'p',
    size: 'sm',
  },
  styles: {
    marginBottom: '1rem',
    lineHeight: 1.6,
  },
});
